import React, { Component } from 'react';
import {connect} from 'react-redux'




const AppUrl = 'https://app.swinity.com/api/creatives';

class SsrBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DomId: this.MakeId(10),
      DoApiClick: this.isNullOrUndefined(props.doApiClick) ? true : props.doApiClick,
      ZoneId: this.isNullOrUndefined(props.ZoneId) ? "" : props.ZoneId,
      Class: this.isNullOrUndefined(props.className) ? "" : props.className,

    };
  }

  componentDidMount() {

  }


  handleClick(e,cre) {
    try {
      if(typeof window !== "undefined" && typeof window.ga !== "undefined") {
        window.ga('send', 'event', 'Banner', 'Click', cre.Click.Name);
      }
      if(typeof window !== "undefined" && typeof window.gtag !== "undefined") {
        window.gtag('event', 'view_promotion', [
          {"creative_name": cre.Creative.Title, "creative_slot": cre.Zone.Name + " - " + window.location.hostname, "id": cre.Click.Guid, "name": cre.Click.Name}
        ]);
      }
    } catch(ex) {}
    if(this.state.DoApiClick) {
      cre.Click.Guid = this.CreateGuid();
      this.apiClick(cre);
    }
  }

  CreateGuid() {
    function _p8(s) {
      let p = (Math.random().toString(16)+"000000000").substr(2,8);
      return s ? "-" + p.substr(0,4) + "-" + p.substr(4,4) : p ;
    }
    return _p8() + _p8(true) + _p8(true) + _p8();
  }

  apiClick(cre) {
    let pge = this.props.WebPage;
    let clk = {
      Channel: pge.Request.Domain.Name.toLowerCase(),
      CountryCode: pge.Request.CountryCode,
      IpAddress: pge.Request.IpAddress,
      AnonymousId: pge.Request.AnonymousId,
      Ads: [],
      UserId:  pge.Request.UserId
    };
    clk.Ads.push(cre);


    let headers = {
      "X-Alt-Referer": window.location.href,
      "Content-type": "application/json"
    };
    if (!this.isNullOrEmpty(this.props.AnonymousId)) {
      headers["X-Alt-AnonymousId"] = this.props.AnonymousId;
    } //Do Not Need Any Resp, Etc.. Log On Error Thats It
    fetch(`${AppUrl}/creatives/impression?Click=true`, {headers: headers, method: "POST", body: JSON.stringify(clk) })
      .catch((ex) => {
        console.log("Error in click call swbanner",ex);
      });
  }

  load() {

  }

  getLinks() { //Filter Links For Zone, Include/Exclude Logic
    let ihme = this.props.IsHome;
    let links = this.props.Ads.ApiResult.filter((ad) => {
      if(ad.Zone) {
        return ad.Zone.Code == this.props.ZoneId;
      } else {
        return false;
      }
    });
    if(!ihme) {
      links = links.filter((ad) => {
        if(ad.Priority) {
          return ad.Priority.Value !== "Standard";
        } else {
          return false;
        }
      });
      console.log("######### - Choosing On Sponser'd Banners - ##########", links);
    }
    let flinks = [];
    let cc = this.props.WebPage.Request.CountryCode;
    if(!this.isNullOrEmpty(this.props.CountryCode)) {
      cc = this.props.CountryCode;
    }
    links.map((lnk)=>{
      let add = true;
      if(lnk.Include.length>0) {
        lnk.Include.map((inc)=>{
          if(inc.Type == "Country") {
            if(inc.Value !== cc) {
              add = false;
            }
          }
        });
      }
      if(lnk.Exclude.length>0) {
        lnk.Exclude.map((exc)=>{
          if(exc.Type == "Country") {
            if(exc.Value == cc) {
              add = false;
            }
          }
          if(exc.Type == "Channel") {
            if(exc.Value == this.props.WebPage.Request.Domain.Name) {
              add = false;
            }
          }
        });
      }
      if(lnk.Creative && lnk.Creative.Campaign && lnk.Creative.Campaign.Name) {
        //console.log(`${this.props.WebPage.Request.Domain.Name.toLowerCase()} == ${lnk.Creative.Campaign.Name.toLowerCase()}`);
        if(this.props.WebPage.Request.Domain.Name.toLowerCase() == lnk.Creative.Campaign.Name.toLowerCase()) {
          add=false;
        }
      }

      if(add) {flinks.push(lnk)}
    });
    return flinks;
  }


  renderBanners() {
    let resp = null; //Render NOTHING
    try {
      let bans = this.getLinks();
      if(this.props.AdsHereCount) {
        let i = this.props.AdsHereCount;
        for(let x=0; x<=i-1; x++) {
          bans.push({Click: {Guid: "" }, Creative: {Code: "ADVERTISEHERE"}});
        }
      }
      if(!this.isNullOrUndefined(bans) && bans.length>0) {
        resp = bans.map((v,i) =>{
          let type = "banner";
          if(v.Creative.Code == "ADVERTISEHERE") {
            type = "ad";
          }
          return (
            <React.Fragment key={`${this.state.DomId}-${v.Creative.Code}-${i}`}>
              {type=="banner" &&
              <div className={this.props.className}><a onClick={(e) => {this.handleClick(e,v)}} href={v.Creative.TargetUrl} target={"_blank"} title={v.Creative.Title} className={this.props.className} rel={v.Rel}>
                <img src={v.Creative.Url} alt={v.Creative.Title} className={this.props.className} onLoad={()=> {
                  if(this.props.BannersLoader) {
                    this.props.BannersLoader.postImpression(v);
                  }
                }}/>
              </a></div>
              }
              {type=="ad" &&
              <div className={this.props.className}>
                {this.props.children}
              </div>
              }
            </React.Fragment>
          );
        });
      }
    } catch(ex) {
      console.log("Error",ex);
    }
    return resp;
  }


  render() {
    return this.renderBanners();
  }



  //Utils Here
  isNullOrUndefined(val) {
    return val === null || typeof val === "undefined";
  }
  isNullOrEmpty(obj) {
    if(typeof obj === "undefined") { return true;}
    if(obj === null) { return true;}
    if(typeof obj === "string") { return obj === "" }
    return false;
  }
  isMoreThenZero(tInt) {
    if(this.isNullOrUndefined(tInt)) return false;
    if(typeof tInt === "string") {
      let cInt = parseInt(tInt,10);
      if(isNaN(cInt)) {
        return false;
      }
      return cInt > 0;
    } else {
      if(typeof tInt === "number") {
        return tInt > 0;
      }
    }
    return false;
  }
  MakeId(length) {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}

const mapStateToProps = (state) => {
  return {
    Ads: state.Ads.SSRAds,
    AnonymousId: state.Website.Request.AnonymousId,
    BannersLoader: state.Ads.BannersLoader,
    WebPage: state.Website
  };
};

export default connect(mapStateToProps)(SsrBanner);


